import { useQuery } from '@tanstack/react-query';
import { requestHandler } from 'lib/api';
import { Dispatch } from 'redux';

import { EconomicActivitiesBlacklist } from './types';

export const addEconomicActivityToBlacklist = async (
  dispatch: Dispatch,
  code: string,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/economicActivitiesBlacklist`,
    data: { code },
    dispatch,
  });
  if (response) return response.data;
};

export const getEconomicActivitiesBlacklist = (dispatch: Dispatch) =>
  useQuery({
    queryKey: ['economicActivitiesBlacklist'],
    queryFn: async (): Promise<EconomicActivitiesBlacklist[] | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/economicActivitiesBlacklist`,
        dispatch,
      });
      if (response) return response.data || [];
    },
    retry: 1,
  });

export const deleteEconomicActivityFromBlacklist = async (
  dispatch: Dispatch,
  id: number,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/economicActivitiesBlacklist/${id}`,
    dispatch,
  });
  if (response) return response.data;
};
